<template>
    <div class="divide-y">
        <div v-for="region in regions" :key="region.RegionId" class="mb-4 pb-4">
            <h3>{{ region.Name }}</h3>
            <div class="ml-4 gap-4 columns-4 text-sm">
                <div v-for="country in region.Countries" :key="country.CountryId" class="-indent-4">
                    {{ country.Name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
type RegionCountry = {
    CountryId: number;
    RegionId: number;
    Name: string;
    IsActive: boolean;
    Code: string;
    Region: {
        RegionId: number;
        Name: string;
        ShortName: string;
        IsActive: boolean;
    };
};

type RegionGroup = {
    RegionId: number;
    Name: string;
    ShortName: string;
    Countries: { CountryId: number; Name: string }[];
};

const { data } = await useApi<RegionCountry[]>("docs/region-countries");

const regions = computed<RegionGroup[]>(() => {
    if (!data.value) return [];

    const regionMap = new Map<number, RegionGroup>();

    data.value.forEach((country) => {
        if (!regionMap.has(country.RegionId)) {
            regionMap.set(country.RegionId, {
                RegionId: country.Region.RegionId,
                Name: country.Region.Name,
                ShortName: country.Region.ShortName,
                Countries: [],
            });
        }

        regionMap.get(country.RegionId)!.Countries.push({
            CountryId: country.CountryId,
            Name: country.Name,
        });
    });

    return Array.from(regionMap.values()).sort((a, b) => a.RegionId - b.RegionId);
});
</script>
